import zootoolsEmailSpellChecker from '@zootools/email-spell-checker';

const POPULAR_SLDS_AU = [
  'com.au',
  'net.au',
  'on.net',
  'gov.au',
  'edu.au',
  'org.au',
];

const POPULAR_SLDS_SG = [
  'sg',
  'com.sg',
  'net.sg',
  'gov.sg',
  'edu.sg',
  'org.sg',
];

const GOVERNMENT_DOMAINS_AU = [
  'sa.gov.au',
  'vic.gov.au',
  'nsw.gov.au',
  'qld.gov.au',
  'wa.gov.au',
  'tas.gov.au',
  'act.gov.au',
  'nt.gov.au',
];

const HEALTHCARE_DOMAINS_AU = [
  'mh.org.au',
  'health.qld.gov.au',
  'health.nsw.gov.au',
  'health.vic.gov.au',
  'health.wa.gov.au',
  'health.sa.gov.au',
  'svha.org.au',
  'northernhealth.org.au',
  'easternhealth.org.au',
];

const EDUCATION_DOMAINS_AU = [
  'education.vic.gov.au',
  'eq.edu.au',
  'education.nsw.gov.au',
  'schools.sa.edu.au',
  'education.wa.edu.au',
  'education.tas.gov.au',
];

const SINGHEALTH_DOMAINS_SG = [
  'singhealth.com.sg',
  'cgh.com.sg',
  'sgh.com.sg',
  'skh.com.sg',
  'kkh.com.sg',
  'nccs.com.sg',
  'ndcs.com.sg',
  'nhcs.com.sg',
  'snec.com.sg',
  'bvh.com.sg',
];

const NHG_DOMAINS_SG = [
  'nhghealth.com.sg',
  'ttsh.com.sg',
  'ktph.com.sg',
  'nsc.com.sg',
  'imh.com.sg',
  'wh.com.sg',
  'nhgp.com.sg',
  'yishuncommunityhospital.com.sg',
];

const NUHS_DOMAINS_SG = [
  'nuhs.edu.sg',
  'nuh.com.sg',
  'ntfgh.com.sg',
  'ah.com.sg',
  'jch.com.sg',
  'nup.com.sg',
  'ncis.com.sg',
  'nuhcs.com.sg',
  'nucohs.com.sg',
];

const POPULAR_SLDS_NZ = [
  'nz',
  'co.nz',
  'net.nz',
  'govt.nz',
  'ac.nz',
  'org.nz',
  'school.nz',
  'geek.nz',
  'iwi.nz',
  'mil.nz',
];

const GOVERNMENT_DOMAINS_NZ = [
  'health.govt.nz',
  'moh.govt.nz',
  'education.govt.nz',
  'justice.govt.nz',
  'police.govt.nz',
  'dia.govt.nz',
  'msd.govt.nz',
  'ird.govt.nz',
  'nzta.govt.nz',
  'stats.govt.nz',
  'worksafe.govt.nz',
  'epa.govt.nz',
  'mfe.govt.nz',
  'doc.govt.nz',
  'linz.govt.nz',
];

const HEALTHCARE_DOMAINS_NZ = [
  'adhb.govt.nz',
  'waitematadhb.govt.nz',
  'cdhb.govt.nz',
  'wdhb.govt.nz',
  'bopdhb.govt.nz',
  'midcentraldhb.govt.nz',
  'waikatodhb.govt.nz',
  'southerndhb.govt.nz',
  'nmdhb.govt.nz',
  'hvdhb.govt.nz',
  'ccdhb.govt.nz',
  'tdhb.govt.nz',
  'whanganuidhb.govt.nz',
  'lakedhb.govt.nz',
  'hbdhb.govt.nz',
  'tairawhitidhb.govt.nz',
  'northlanddhb.govt.nz',
  'westcoastdhb.govt.nz',
  'nelsontasman.health.nz',
  'marlboroughdhb.govt.nz',
  'southcanterburydhb.govt.nz',
  'healthalliance.co.nz',
  'starship.org.nz',
];

const EDUCATION_DOMAINS_NZ = [
  'aucklanduni.ac.nz',
  'aut.ac.nz',
  'waikato.ac.nz',
  'massey.ac.nz',
  'vuw.ac.nz',
  'canterbury.ac.nz',
  'lincoln.ac.nz',
  'otago.ac.nz',
  'unitec.ac.nz',
  'op.ac.nz',
  'nmit.ac.nz',
  'toiohomai.ac.nz',
  'weltec.ac.nz',
  'whitireia.ac.nz',
  'ucol.ac.nz',
  'eastern.ac.nz',
  'nzma.ac.nz',
];

const EMAIL_PROVIDERS_DOMAINS_NZ = [
  'xtra.co.nz',
  'slingshot.co.nz',
  'orcon.net.nz',
  'ihug.co.nz',
  'clear.net.nz',
  'vodafone.co.nz',
  'spark.co.nz',
  '2degrees.nz',
];

const NATIONAL_AGENCIES_SG = [
  'moh.gov.sg',
  'hpb.gov.sg',
  'hsa.gov.sg',
  'aic.sg',
  'synapxe.sg',
  'healthhub.sg',
];

const EMAIL_PROVIDERS_DOMAINS_AU = [
  'hotmail.com.au',
  'live.com.au',
  'bigpond.net.au',
  'optusnet.com.au',
  'iinet.net.au',
  'internode.on.net',
  'westnet.com.au',
  'dodo.com.au',
  'aapt.net.au',
  'ozemail.com.au',
  'exemail.com.au',
  'netspace.net.au',
  'spin.net.au',
];

const emailSpellChecker = (email) => {
  return zootoolsEmailSpellChecker.run({
    email,
    domains: [
      ...zootoolsEmailSpellChecker.POPULAR_DOMAINS,
      ...HEALTHCARE_DOMAINS_AU,
      ...GOVERNMENT_DOMAINS_AU,
      ...EDUCATION_DOMAINS_AU,
      ...EMAIL_PROVIDERS_DOMAINS_AU,
      ...SINGHEALTH_DOMAINS_SG,
      ...NHG_DOMAINS_SG,
      ...NUHS_DOMAINS_SG,
      ...NATIONAL_AGENCIES_SG,
      ...HEALTHCARE_DOMAINS_NZ,
      ...GOVERNMENT_DOMAINS_NZ,
      ...EDUCATION_DOMAINS_NZ,
      ...EMAIL_PROVIDERS_DOMAINS_NZ,
      ...POPULAR_SLDS_AU,
      ...POPULAR_SLDS_SG,
      ...POPULAR_SLDS_NZ,
    ],
    topLevelDomains: [
      ...zootoolsEmailSpellChecker.POPULAR_TLDS,
      ...POPULAR_SLDS_AU,
      ...POPULAR_SLDS_SG,
      ...POPULAR_SLDS_NZ,
    ],
  });
};

export const getFormattedSuggestion = (email) => {
  if (!email || !email.includes('@')) {
    return '';
  }

  const suggestion = emailSpellChecker(email);

  if (!suggestion) {
    return '';
  }

  return `Did you mean ${suggestion.full}?`;
};

export default emailSpellChecker;
